<div fxLayout="column" fxLayoutGap="8px">
    <div fxLayout="row" fxLayoutGap="8px">
        <button mat-icon-button><mat-icon>add</mat-icon></button>
        <button mat-icon-button><mat-icon>edit</mat-icon></button>
        <button mat-icon-button><mat-icon>delete</mat-icon></button>
        <button mat-icon-button class="font-size-20">
            <i class="fas fa-barcode"></i>
        </button>
    </div>
    <div>
        <img src="" alt="">
    </div>
    <div fxLayout="row" fxLayoutGap="8px">
        <div>
            Code
        </div>
        <div>
            Civilité
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="8px">
        <div>
            N° Carte fidélité
        </div>
        <div>
            Points fidélité
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="8px">
        <div>
            Name
        </div>
        <div>
            Email
        </div>
        <div>
            Email 2
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="8px">
        <div>
            Tel
        </div>
        <div>
            Email
        </div>
    </div>
    <div fxLayout="row" fxLayoutGap="8px">
        <div>
            Address
        </div>
        <div>
            City
        </div>
    </div>
    <div>
        Vendeur
    </div>
    <div>
        Commentaire
    </div>
    <div>
        Passeport
    </div>
    <div>
        Language
    </div>
    <div>
        Date de naissance
    </div>
</div>